function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "inductor");

var SvgInductor = function SvgInductor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bcb2ef73-f4fd-4f3f-a146-780b7c5840fa",
    "data-name": "Ebene 1",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "a40eac83-df88-4b73-b9f2-d24038c71f73",
    "data-name": "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a7d3d561-1f54-409c-a7ac-415338aee8d1",
    "data-name": "Shape",
    d: "M301.06,417.28a8.53,8.53,0,0,0-9.54,7.39l-9.85,77.71a8.52,8.52,0,0,0,7.39,9.54,7.59,7.59,0,0,0,1.07.08,8.53,8.53,0,0,0,8.46-7.46l9.85-77.71a8.55,8.55,0,0,0-7.38-9.55Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,25.6c-117.82,0-213.33,95.51-213.33,213.33S138.18,452.27,256,452.27s213.33-95.52,213.33-213.34A213.32,213.32,0,0,0,256,25.6Zm0,332.8a119.46,119.46,0,1,1,84.48-35A119.47,119.47,0,0,1,256,358.4Z",
    style: {
      fill: "#f29c1f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,0a8.53,8.53,0,0,0-8.53,8.53V128a8.53,8.53,0,1,0,17.06,0V8.53A8.53,8.53,0,0,0,256,0Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.61,14.17a8.53,8.53,0,1,0-16.48,4.42L219,134a8.54,8.54,0,1,0,16.49-4.42Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.14,147.13a8.53,8.53,0,1,0,14.78-8.53L148.19,35.13a8.54,8.54,0,0,0-14.78,8.54Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.86,330.73a8.54,8.54,0,1,0-14.78,8.54l59.73,103.46a8.53,8.53,0,0,0,14.78-8.53Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.52,166.53a8.54,8.54,0,1,0,12.07-12.08L99.11,70A8.54,8.54,0,1,0,87,82.05Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.48,311.34a8.53,8.53,0,0,0-12.07,12.07l84.48,84.48A8.53,8.53,0,1,0,425,395.82Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2,131.12l103.47,59.74a8.53,8.53,0,1,0,8.53-14.78L60.73,116.34a8.53,8.53,0,0,0-8.53,14.78Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.8,346.74,356.33,287a8.53,8.53,0,0,0-8.53,14.78l103.47,59.73a8.53,8.53,0,0,0,8.53-14.78Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.24,187.55l115.4,30.9a8.24,8.24,0,0,0,2.21.3A8.53,8.53,0,0,0,151.06,202L35.66,171.06a8.54,8.54,0,0,0-4.42,16.49Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.76,290.32l-115.4-30.91a8.54,8.54,0,0,0-4.42,16.49l115.4,30.92a7.92,7.92,0,0,0,2.22.29,8.53,8.53,0,0,0,2.2-16.78Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.07,247.47a8.54,8.54,0,0,0,0-17.07H25.6a8.54,8.54,0,0,0,0,17.07Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.4,230.4H366.93a8.54,8.54,0,0,0,0,17.07H486.4a8.54,8.54,0,0,0,0-17.07Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.09,265.44a8.55,8.55,0,0,0-10.45-6L31.24,290.32a8.54,8.54,0,0,0,2.2,16.79,8.31,8.31,0,0,0,2.22-.3L151,275.89a8.53,8.53,0,0,0,6.05-10.45Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.91,212.43a8.54,8.54,0,0,0,8.24,6.33,8.24,8.24,0,0,0,2.21-.3l115.4-30.91a8.54,8.54,0,0,0-4.42-16.49L361,202a8.53,8.53,0,0,0-6,10.45Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.32,290.13A8.52,8.52,0,0,0,155.67,287L52.2,346.74a8.53,8.53,0,1,0,8.53,14.78L164.2,301.79A8.54,8.54,0,0,0,167.32,290.13Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.68,187.73a8.53,8.53,0,0,0,11.65,3.13L459.8,131.12a8.53,8.53,0,0,0-8.53-14.78L347.8,176.08a8.52,8.52,0,0,0-3.12,11.65Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.59,311.34a8.53,8.53,0,0,0-12.06,0L87.05,395.82a8.53,8.53,0,1,0,12.06,12.07l84.48-84.48a8.51,8.51,0,0,0,0-12.07Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.41,166.53a8.53,8.53,0,0,0,12.06,0L425,82.05A8.53,8.53,0,1,0,412.89,70l-84.48,84.48a8.52,8.52,0,0,0,0,12.08Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.2,150.25a8.54,8.54,0,0,0,11.66-3.12L378.59,43.67a8.54,8.54,0,0,0-14.78-8.54L304.08,138.6a8.52,8.52,0,0,0,3.12,11.65Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.24,326.64a8.53,8.53,0,0,0-9.08,4.09L133.43,434.2a8.53,8.53,0,1,0,14.78,8.53l47.06-81.51,18.15,143.31a8.54,8.54,0,0,0,8.45,7.47,7.59,7.59,0,0,0,1.07-.07,8.53,8.53,0,0,0,7.4-9.53L209,333.93a8.53,8.53,0,0,0-6.77-7.29Z",
    style: {
      fill: "#d25627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.71,140.31A8.53,8.53,0,0,0,293,134l30.91-115.4a8.53,8.53,0,1,0-16.48-4.42l-30.91,115.4a8.53,8.53,0,0,0,8.24,10.74Z",
    style: {
      fill: "#d25627"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInductor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inductor.358705da.svg";
export { ForwardRef as ReactComponent };